import React from "react";
import PageMeta from "@insightfulscience/smart-react/PageMeta";
import { useLocale, WithLocale } from "@insightfulscience/i18";
import Hero from "@insightfulscience/atomic-react/Hero";
import HeroTitle from "@insightfulscience/atomic-react/Hero/Title";
import Section from "@insightfulscience/atomic-react/Section";
import { Col, Container, Row } from "@insightfulscience/atomic-react/Grid";
import Link from "@insightfulscience/atomic-react/Link";
import { ContactParagraph, ContactTitle } from "@insightfulscience/atomic-react/ContactElement";
import pipe from "@insightfulscience/shared-utils/fn/pipe";
import SiteLayout from "@src/SiteLayout";
import resources from "../locales/contact-page";

const Contact = () => {
	const [t] = useLocale("contact");
	return (
		<SiteLayout hero>
			<PageMeta title={t("PAGE_TITLE")} description={t("META_DESCRIPTION")}>
				<PageMeta.OGP
					title={t("PAGE_TITLE")}
					description={t("META_DESCRIPTION")}
					locale={t("META_LOCALE")}
					type={t("META_TYPE")}
					url={t("META_URL")}
					image={t("META_IMAGE")}
					imageSecureUrl={t("META_IMAGE_SECURE")}
					siteName={t("META_SITE_NAME")}
					articlePublisher={t("META_ARTICLE_PUBLISHER")}
					isImageBaseUrl
				/>
				<PageMeta.Twitter
					title={t("PAGE_TITLE")}
					description={t("META_DESCRIPTION")}
					site={t("META_TWITTER_SITE")}
					card={t("META_TWITTER_CARD")}
					image={t("META_TWITTER_IMAGE")}
					creator={t("META_TWITTER_CREATOR")}
					isImageBaseUrl
				/>
				<PageMeta.Canonical href={t("META_CANONICAL")} />
				<PageMeta.Author content={t("META_AUTHOR")} />
			</PageMeta>
			<Hero>
				<HeroTitle>{t("HERO_TITLE")}</HeroTitle>
			</Hero>
			<Section spacing={{ py: 20 }}>
				<Container>
					<Row utility={{ justify: "center" }}>
						<Col sm={12} md={8} lg={5}>
							<ContactTitle type={1}>{t("CONTACT_HEADING")}</ContactTitle>
							<ContactParagraph type={1}>{t("CONTACT_CUSTOMERS")}</ContactParagraph>
							<ContactTitle type={2}>{t("CONTACT_WORLDWIDE")}</ContactTitle>
							<ContactParagraph type={2}>
								<Link
									target="_blank"
									href="https://support.snapgene.com/hc/en-us/requests/new?ticket_form_id=360000552331"
								>
									{t("CONTACT_SALES_AND_SUPPORT")}
								</Link>
							</ContactParagraph>
							<ContactParagraph type={1} className="mb-20">
								{t("CONTACT_ADDRESS_1")} <br />
								{t("CONTACT_ADDRESS_2")} <br />
								{t("CONTACT_ADDRESS_3")}
							</ContactParagraph>
							<ContactTitle type={2}>{t("CONTACT_CHINA_TITLE")}</ContactTitle>
							<ContactParagraph type={2}>{t("CONTACT_CHINA_OPTIONS")}</ContactParagraph>
							<ContactParagraph type={3}>
								<Link target="_blank" href="https://www.snapgene.cn/#contact">
									{t("CONTACT_CHINA_SALES")}
								</Link>
							</ContactParagraph>
							<ContactParagraph type={3}>
								<Link target="_blank" href="https://www.snapgene.cn/">
									{t("CONTACT_CHINA_WEBSITE")}
								</Link>
							</ContactParagraph>
						</Col>
					</Row>
				</Container>
			</Section>
		</SiteLayout>
	);
};

export default pipe(Contact, WithLocale({ resources }));
